import { render, staticRenderFns } from "./FormCardItem.vue?vue&type=template&id=0f24424d"
import script from "./FormCardItem.vue?vue&type=script&lang=js"
export * from "./FormCardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports